import styled from 'styled-components'

export const SearchInputContainer = styled.div`
  display: flex;
  height: 40px;
  border: ${({ theme }) => `2px solid ${theme.colors.greyE5}`};
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 8px;
  box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.5);
  padding-left: 5px;
  & input {
    border: none;
    height: inherit;
    padding: calc(0.5rem - 2px) calc(1rem - 2px);

    &:active,
    &:focus {
      box-shadow: none;
    }
  }
`

export const SearchGlassContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-left: ${({ theme }) => `2px solid ${theme.colors.greyE5}`};
  height: 40px;
  width: 40px;
`
